// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-button {
    padding: 10px 0;
}
.radio-button label.radio-button__label {
    display: block;
    box-sizing: border-box;
    width: 100%;
    text-align: left;
    padding: 5px 0;
}
.radio-button .radio-button__explanation {
    font-size: 12px;
    padding: 0 0 5px 5px;
    font-style: italic;
    text-align: left;
}
.radio-button__wrapper {
    box-sizing: border-box;
    padding: 20px;
    background-color: white;
    border-radius: 7px;
    border: thin solid var(--main-border-color);
}
.radio-option {
    display: grid;
    grid-template-columns: auto 40px;
    align-items: center;
    padding: 10px;
}
.radio-option__label {
    font-weight: bold;
    font-size: 18px;
    text-align: left;
}
.radio-option__explanation {
    font-size: 12px;
    font-style: italic;
    text-align: left;
}
.radio-option__button {
    display: block;
    width: 40px;
    height: 20px;
}

@media ( width < 700px ) {
    .radio-button label.radio-button__label {
        text-align: center;
        padding: 5px;
    }
    .radio-button .radio-button__explanation {
        text-align: center;
        padding: 5px;
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/ui/Radio/Radio.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,YAAY;IAChB;AACJ","sourcesContent":[".radio-button {\n    padding: 10px 0;\n}\n.radio-button label.radio-button__label {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n    text-align: left;\n    padding: 5px 0;\n}\n.radio-button .radio-button__explanation {\n    font-size: 12px;\n    padding: 0 0 5px 5px;\n    font-style: italic;\n    text-align: left;\n}\n.radio-button__wrapper {\n    box-sizing: border-box;\n    padding: 20px;\n    background-color: white;\n    border-radius: 7px;\n    border: thin solid var(--main-border-color);\n}\n.radio-option {\n    display: grid;\n    grid-template-columns: auto 40px;\n    align-items: center;\n    padding: 10px;\n}\n.radio-option__label {\n    font-weight: bold;\n    font-size: 18px;\n    text-align: left;\n}\n.radio-option__explanation {\n    font-size: 12px;\n    font-style: italic;\n    text-align: left;\n}\n.radio-option__button {\n    display: block;\n    width: 40px;\n    height: 20px;\n}\n\n@media ( width < 700px ) {\n    .radio-button label.radio-button__label {\n        text-align: center;\n        padding: 5px;\n    }\n    .radio-button .radio-button__explanation {\n        text-align: center;\n        padding: 5px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
